<template>
  <div>
    <div class="d-inline-block mr-2 mt-3 mt-sm-0 mb-3 mb-sm-3">
      <a-input-search placeholder="Search by name..." @search="onSearch" />
    </div>
    <div class="mb-4">
      <a-table
        :columns="columns"
        :dataSource="filteredData"
        :pagination="true"
        :class="$style.table"
        rowKey="id"
        :loading="isLoading"
      >
        <template slot="name" slot-scope="name, record">
          <div>
            <div v-if="isAdmin">
              <router-link
                :to="{ path: '/farmasi/details/' + record.id }"
                class="kit__utils__link font-size-16"
                >{{ record.name }}</router-link
              >
            </div>
            <div v-if="!isAdmin">{{ record.name }}</div>
            <div class="text-gray-4">{{ record.city ? record.city : '-' }}</div>
          </div>
        </template>
        <template slot="createdAt" slot-scope="createdAt">
          <div>
            <div>
              {{ createdAt ? moment(createdAt).format('DD MMM YYYY') : '-' }}
            </div>
          </div>
        </template>
        <template slot="address" slot-scope="address">
          <div>
            <div>{{ address ? address : '-' }}</div>
          </div>
        </template>
        <template slot="city" slot-scope="city">
          <div>
            <div>{{ city ? city : '-' }}</div>
          </div>
        </template>
        <template slot="certificate" slot-scope="certificate">
          <div>
            <div>{{ certificate ? certificate : '-' }}</div>
          </div>
        </template>
        <template slot="message" slot-scope="message">
          <div>
            <div>{{ message ? message : '-' }}</div>
          </div>
        </template>
        <template slot="email" slot-scope="email">
          <div>
            <div>{{ email ? email : '-' }}</div>
          </div>
        </template>
        <template slot="isApproved" slot-scope="isApproved">
          <div>
            <div>
              {{
                isApproved == true
                  ? 'Disetujui'
                  : isApproved == false
                  ? 'Ditolak'
                  : 'Menunggu Verifikasi'
              }}
            </div>
          </div>
        </template>
        <template slot="aksi" slot-scope="text, record">
          <a-button
            type="primary"
            @click="openAssessmentModal(record)"
            :disabled="!isAdmin"
          >
            Download Assessment
          </a-button>
        </template>
      </a-table>
    </div>

    <!-- Modal List Assessment -->
    <a-modal
      title="Pilih Assessment"
      :visible="assessmentModalVisible"
      @cancel="closeAssessmentModal"
      :footer="null"
    >
      <a-spin v-if="loadingAssessments" />
      <div v-else-if="assessmentsOptions.length === 0">
        Belum ada assessment yang disubmit.
      </div>
      <a-table
        v-else
        :columns="modalColumns"
        :dataSource="assessmentsOptions"
        :pagination="false"
        rowKey="id"
      >
        <template slot="quarter" slot-scope="text, record">
          Q{{ record.quarter }} - {{ record.year }}
        </template>
        <template slot="submittedAt" slot-scope="text">
          {{
            text ? moment(text).locale('id').format('DD MMMM YYYY HH:mm') : '-'
          }}
        </template>
        <template slot="download" slot-scope="text, record">
          <a-button
            type="primary"
            @click="downloadAssessment(record)"
            :loading="downloadingId === record.id"
          >
            Download PDF
          </a-button>
        </template>
      </a-table>
    </a-modal>

    <!-- Hidden PDF Element -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="pdfFilename"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2Pdf"
    >
      <section slot="pdf-content" class="p-4 bg-white text-dark">
        <div v-if="selectedAssessmentDetails">
          <h2 class="text-center mb-4">Hasil Pharmacy Self Assessment</h2>
          <div class="mb-4">
            <p><strong>Nama Farmasi:</strong> {{ selectedPharmacyName }}</p>
            <p>
              <strong>Periode:</strong> Q{{
                selectedAssessmentDetails.quarter
              }}
              - {{ selectedAssessmentDetails.year }}
            </p>
            <p>
              <strong>Tanggal Submit:</strong>
              {{
                moment(selectedAssessmentDetails.submittedAt)
                  .locale('id')
                  .format('DD MMMM YYYY HH:mm')
              }}
            </p>
          </div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="width: 5%">No</th>
                <th style="width: 55%">Pertanyaan</th>
                <th style="width: 40%">Jawaban</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(ans, index) in selectedAssessmentDetails.answers"
                :key="ans.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ ans.question ? ans.question.questionText : '-' }}</td>
                <td>
                  <span v-if="ans.booleanValue !== null">{{
                    ans.booleanValue ? 'Ya' : 'Tidak'
                  }}</span>
                  <span v-else-if="ans.scaleValue !== null">{{
                    ans.scaleValue
                  }}</span>
                  <span v-else-if="ans.numberValue !== null">{{
                    ans.numberValue
                  }}</span>
                  <span v-else-if="ans.textValue !== null">{{
                    ans.textValue
                  }}</span>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import { getAll } from '@/services/axios/api/farmasi'
import {
  getAll as getAssessments,
  getById as getAssessmentById,
} from '@/services/axios/api/pharmacyAssessment'
import VueHtml2pdf from 'vue-html2pdf'
import fuzzysort from 'fuzzysort'
import moment from 'moment'

moment.locale('id')

const columns = [
  {
    title: 'Nama Farmasi',
    dataIndex: 'name',
    className: 'bg-transparent text-gray-6 width-50',
    fixed: 'left',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => {
      return a.name.localeCompare(b.name)
    },
    filters: [],
    onFilter: (value, record) => {
      return record.city === value
    },
  },
  {
    title: 'Email',
    dataIndex: 'email',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'email' },
    sorter: (a, b) => {
      return a.email.localeCompare(b.email)
    },
  },
  {
    title: 'Tanggal Bergabung',
    dataIndex: 'createdAt',
    className: 'bg-transparent text-gray-6 width-50',
    scopedSlots: { customRender: 'createdAt' },
    sorter: (a, b) => {
      return a.createdAt.localeCompare(b.createdAt)
    },
  },
  {
    title: 'Alamat Farmasi',
    dataIndex: 'address',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'address' },
    sorter: (a, b) => {
      return a.address.localeCompare(b.address)
    },
  },
  // {
  //   title: 'Kota',
  //   dataIndex: 'city',
  //   className: 'bg-transparent text-gray-6',
  //   scopedSlots: { customRender: 'city' },
  //   sorter: (a, b) => { return a.city.localeCompare(b.city) },
  // },
  // {
  //   title: 'Sertifikat',
  //   dataIndex: 'certificate',
  //   className: 'bg-transparent text-gray-6',
  //   scopedSlots: { customRender: 'certificate' },
  //   sorter: (a, b) => { return a.certificate.localeCompare(b.certificate) },
  // },
  {
    title: 'Status',
    dataIndex: 'isApproved',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'isApproved' },
    sorter: (a, b) => {
      return a.isApproved.localeCompare(b.isApproved)
    },
  },
  {
    title: 'Aksi',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'aksi' },
    fixed: 'right',
  },
]

const modalColumns = [
  {
    title: 'Periode',
    key: 'quarter',
    scopedSlots: { customRender: 'quarter' },
  },
  {
    title: 'Tanggal Disubmit',
    dataIndex: 'submittedAt',
    scopedSlots: { customRender: 'submittedAt' },
  },
  { title: 'Aksi', scopedSlots: { customRender: 'download' } },
]

export default {
  name: 'TabelFarmasi',
  components: {
    VueHtml2pdf,
  },
  data: function () {
    return {
      columns,
      modalColumns,
      items: [],
      isLoading: true,
      filteredData: [],
      isAdmin: false,
      assessmentModalVisible: false,
      loadingAssessments: false,
      assessmentsOptions: [],
      selectedPharmacyName: '',
      selectedAssessmentDetails: null,
      pdfFilename: 'Pharmacy_Assessment.pdf',
      downloadingId: null,
    }
  },
  created() {
    this.getListData()
    this.getRole()
  },
  methods: {
    moment,
    onSearch(searchText) {
      if (searchText !== '') {
        const results = fuzzysort.go(searchText, this.items, { key: 'name' })
        const filteredData = results.map((result) => {
          return result.obj
        })
        console.log(results)
        this.filteredData = filteredData
      } else {
        this.filteredData = this.items
      }
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      // console.log(role)
      if (role === 'admin' || role === 'apl' || role === 'astrazeneca') {
        this.isAdmin = true
      }
    },
    async getListData() {
      const cityFilters = []
      const cityFiltersComparison = []
      let res = await getAll()
      res = res.filter((el) => el.isApproved === true)
      console.log(res.length, 'farmasi')
      for (const i in res) {
        const user = res[i]
        if (user.city) {
          const comparison = user.city.toUpperCase()
          if (!cityFiltersComparison.includes(comparison)) {
            cityFilters.push(user.city)
            cityFiltersComparison.push(comparison)
          }
        }
      }
      cityFilters.forEach((el) => {
        columns[0].filters.push({
          text: el,
          value: el,
        })
      })
      this.columns = columns
      this.isLoading = false
      this.items = res
      this.filteredData = res
    },
    async openAssessmentModal(record) {
      if (!this.isAdmin) return
      this.selectedPharmacyName = record.name
      this.assessmentModalVisible = true
      this.loadingAssessments = true
      this.assessmentsOptions = []
      try {
        const res = await getAssessments({ pharmacyId: record.id })
        console.log(res, '<<<<<DSIINI')
        this.assessmentsOptions = res.data.filter(
          (el) => el.status === 'submitted',
        )
      } catch (err) {
        console.error(err)
      } finally {
        this.loadingAssessments = false
      }
    },
    closeAssessmentModal() {
      this.assessmentModalVisible = false
    },
    async downloadAssessment(record) {
      this.downloadingId = record.id
      try {
        const details = await getAssessmentById(record.id)
        if (details) {
          this.selectedAssessmentDetails = details.data
          this.pdfFilename = `Assessment_${this.selectedPharmacyName.replace(
            /\s+/g,
            '_',
          )}_Q${record.quarter}_${record.year}.pdf`
          // Wait for DOM to update with selectedAssessmentDetails
          await this.$nextTick()
          this.$refs.html2Pdf.generatePdf()
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.downloadingId = null
      }
    },
  },
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
